import {CUSTOM_ELEMENTS_SCHEMA, Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {catchError, from, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {toSignal} from '@angular/core/rxjs-interop';
import {ApplicationInfoService} from '../../services/application-info/application-info.service';
import {MsAuthService} from '../../module/ms-auth';
import {VwuiAngularModule} from "@bvgo-ict/vwui-angular";

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
    standalone: true,
    imports: [DatePipe, TranslatePipe, VwuiAngularModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VersionComponent {
    private readonly applicationInfoService = inject(ApplicationInfoService);
    private readonly authService = inject(MsAuthService);

    public readonly info = toSignal(
        from(this.authService.isReady()).pipe(
            switchMap(() => this.applicationInfoService.getInfo()),
            catchError(() => of(null))
        ),
        {initialValue: null}
    );
}
